module.exports = __webpack_public_path__ + "img/icon-fastest-parking.80356c36.png";